import { render, staticRenderFns } from "./InvoiceForm.vue?vue&type=template&id=fa212f8c&lang=pug"
import script from "./InvoiceForm.vue?vue&type=script&lang=js"
export * from "./InvoiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports